import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'inline-flex !important',
    marginLeft: ({ noMarginLeft }) => !noMarginLeft && '1rem',
    width: 'auto',

    '& input': {
      height: ({ inputHeight }) => `${inputHeight}px !important`,
      fontSize: ({ fontSize }) => fontSize && `${fontSize} !important`,
      width: ({ autoWidth }) => autoWidth && ` auto !important`,
      opacity: ({ opacity }) => opacity && ` ${opacity} !important`
    },

    '& .form-control ': {
      border: ({ borderless }) => borderless && '0px !important'
    },

    '& .flag-dropdown ': {
      border: ({ borderless }) => borderless && '0px !important',
      backgroundColor: ({ borderless }) => borderless && 'white !important'
    }
  }
}))

export default useStyles
